// extracted by mini-css-extract-plugin
export default {"container":"styles_container__NdvZ3","section":"styles_section__W1Rgu"};